import makeIconComponent from '../Icon/Icon';
import { add, arrowDown, arrowRight, calendar, check, clear, close, closeFillCircle, deleteIcon, dropDown, errorOutline, event, file, helpFill, helpOutline, microphone, moreAction, next, playerFullscreen, playerMute, playerNext, playerPause, playerPlay, playerPrevious, playerVolume, previous, save, search, star, upload } from '../Icon/svgIcons';
const iconPlugin = {
    install(vue, options = { registry: new Map() }) {
        const map = options.registry;
        vue.addIcon = (iconName, svg) => {
            map.set(iconName, svg);
        };
        vue.addIconAsync = (iconName, url) => {
            const promise = fetch(url)
                .then((response) => response.text());
            map.set(iconName, promise);
        };
        vue.component('mom-icon', makeIconComponent(map));
        map.set('add', add);
        map.set('check', check);
        map.set('clear', clear);
        map.set('close', close);
        map.set('close-fill-circle', closeFillCircle);
        map.set('delete', deleteIcon);
        map.set('drop-down', dropDown);
        map.set('error-outline', errorOutline);
        map.set('event', event);
        map.set('file', file);
        map.set('help-fill', helpFill);
        map.set('help-outline', helpOutline);
        map.set('microphone', microphone);
        map.set('more-action', moreAction);
        map.set('next', next);
        map.set('previous', previous);
        map.set('arrow-down', arrowDown);
        map.set('arrow-right', arrowRight);
        map.set('save', save);
        map.set('star', star);
        map.set('player-previous', playerPrevious);
        map.set('player-pause', playerPause);
        map.set('player-fullscreen', playerFullscreen);
        map.set('player-mute', playerMute);
        map.set('player-volume', playerVolume);
        map.set('player-next', playerNext);
        map.set('player-play', playerPlay);
        map.set('search', search);
        map.set('upload', upload);
        map.set('calendar', calendar);
    }
};
export default iconPlugin;
//# sourceMappingURL=IconPlugin.js.map